import { useSlots } from 'vue'

interface FieldHelpBinding {
  /** Whether help copy or a `help` slot is present; evaluated per render because slots are not reactive. */
  hasHelp: () => boolean
  /** Value for UFormField's `help` prop; evaluated per render. */
  helpBinding: () => string
}

// UFormField lists the help element in aria-describedby only for a non-empty `help` prop,
// so slot-only help needs a non-empty value; the slot content replaces it in the markup.
const SLOT_HELP_PLACEHOLDER = ' '

export function useFieldHelp(help: () => string): FieldHelpBinding {
  const slots = useSlots()
  const hasHelp = (): boolean => help() !== '' || slots['help'] !== undefined
  const helpBinding = (): string => {
    if (hasHelp()) return help() === '' ? SLOT_HELP_PLACEHOLDER : help()
    return ''
  }
  return { hasHelp, helpBinding }
}
